
// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
// import Notifications from 'react-notification-system-redux'
import { protocol, origin } from '../../../store/addons'

export const GET_DATA = 'GET_DATA'
export const GET_DATA_BASELINE = 'GET_DATA_BASELINE'

// ------------------------------------
// Actions
// ------------------------------------

const getDataAction = (data = undefined) => {
  return {
    type: GET_DATA,
    data: data
  }
}

const getDataBaselineAction = (data = undefined) => {
  return {
    type: GET_DATA_BASELINE,
    data: data
  }
}

export const getData = (id) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      axios.get(`${protocol}//${origin}/api/step/mafia?initId=${id}`)
        .then((json) => {
          let data = []
          json.data.map((key, i) => {
            let obj = {}
            let copyObj = { ...json.data[i] }
            let levels = []
            key && Object.keys(key).map(k => {
              obj[k] = copyObj[k]
              if (!(key === 'o1' || key === 'o2' || key === 'o3' || key === 'o4')) {
                let level = {
                  '-1': 0,
                  '0': 0,
                  '1': 0,
                  '2': 0,
                  '3': 0,
                  '4': 0,
                  '5': 0
                }
                for (let i = 0; i < copyObj[k].length; i += 1) {
                  level[copyObj[k][i].id] = copyObj[k][i].value
                }
                levels[k] = level
              }
            })
            obj.levels = levels
            data.push({ ...obj })
          })
          dispatch(getDataAction(data))
          resolve()
        })
        .catch((error) => {
          console.log(error)
          resolve()
        })
    })
  }
}

export const getDataBaseline = (id) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      axios.get(`${protocol}//${origin}/api/step/mafia?initId=${id}`)
        .then((json) => {
          let data = []
          json.data.map((key, i) => {
            let obj = {}
            let copyObj = { ...json.data[i] }
            let levels = []
            key && Object.keys(key).map(k => {
              obj[k + 'b'] = copyObj[k]
              if (!(key === 'o1' || key === 'o2' || key === 'o3' || key === 'o4')) {
                let level = {
                  '-1': 0,
                  '0': 0,
                  '1': 0,
                  '2': 0,
                  '3': 0,
                  '4': 0,
                  '5': 0
                }
                for (let i = 0; i < copyObj[k].length; i += 1) {
                  level[copyObj[k][i].id] = copyObj[k][i].value
                }
                levels[k] = level
              }
            })
            obj.levelsb = levels
            data.push({ ...obj })
          })
          dispatch(getDataBaselineAction(data))
          resolve()
        })
        .catch((error) => {
          console.log(error)
          resolve()
        })
    })
  }
}

export const actions = { getData, getDataBaseline }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_DATA]: (state, action) => {
    return {
      ...state,
      data: action.data
    }
  },
  [GET_DATA_BASELINE]: (state, action) => {
    return {
      ...state,
      dataBaseline: action.data
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  data: [],
  dataBaseline: []
}

export default function stepfirstReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/StepSecond/modules/stepsecond.js